"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPathPrefix = exports.getConfigurationType = exports.isPpConfiguration = exports.isRpConfiguration = exports.isEvpConfiguration = exports.isLpConfiguration = exports.ConfigurationType = void 0;
__exportStar(require("./common"), exports);
__exportStar(require("./landing_page"), exports);
__exportStar(require("./embed_video_page"), exports);
__exportStar(require("./review_page"), exports);
__exportStar(require("./preview_page"), exports);
var ConfigurationType;
(function (ConfigurationType) {
    ConfigurationType["LandingPage"] = "LandingPage";
    ConfigurationType["Embed"] = "Embed";
    ConfigurationType["Review"] = "Review";
    ConfigurationType["Preview"] = "Preview";
})(ConfigurationType || (exports.ConfigurationType = ConfigurationType = {}));
function isLpConfiguration(configuration) {
    return !("__type" in configuration);
}
exports.isLpConfiguration = isLpConfiguration;
function isEvpConfiguration(configuration) {
    return ("__type" in configuration
        && configuration.__type === "EmbedVideoPageConfiguration");
}
exports.isEvpConfiguration = isEvpConfiguration;
function isRpConfiguration(configuration) {
    return ("__type" in configuration
        && configuration.__type === "ReviewPageConfiguration");
}
exports.isRpConfiguration = isRpConfiguration;
function isPpConfiguration(configuration) {
    return ("__type" in configuration
        && configuration.__type === "PreviewPageConfiguration");
}
exports.isPpConfiguration = isPpConfiguration;
function getConfigurationType(configuration) {
    if (isLpConfiguration(configuration)) {
        return ConfigurationType.LandingPage;
    }
    if (isEvpConfiguration(configuration)) {
        return ConfigurationType.Embed;
    }
    if (isRpConfiguration(configuration)) {
        return ConfigurationType.Review;
    }
    if (isPpConfiguration(configuration)) {
        return ConfigurationType.Preview;
    }
    throw new Error(`Configuration type unknown for ${JSON.stringify(configuration)}`);
}
exports.getConfigurationType = getConfigurationType;
function getPathPrefix(configurationType) {
    return `/render${configurationType}`;
}
exports.getPathPrefix = getPathPrefix;
//# sourceMappingURL=index.js.map